
<div class="w-100">
  <router-outlet></router-outlet>
</div>
